import OptimizePage from "./optimize_page/index.js";
import EventTracker from "./event_tracking/index.js";
// import MarketingCard from './marketing_card/index.js';
import LogHelper from "./utils/logHelper.js";
import AutoCoupon from "./auto_coupon/index.js";
import DetectLogin from "./detect_login/index.js";
import DetectInstallSDK from "./detect_install_sdk/index.js";
import SubscriptionTable from "./subscription_table/index.js";
import IframeMessageListener from "./message_listener/index.js";
import Utils from "./utils/utils.js";

async function initializeSDK(container_id, is_debug) {
  let config = null;
  switch (APP_MODE) {
    case "development":
      config = require("../development.config.js");
      break;
    case "staging":
      config = require("../staging.config.js");
      break;
    case "production":
      config = require("../production.config.js");
      break;
  }
  
  if (!container_id) {
    console.log('empty_container_id', container_id)
    try {
      const utilsHelper = new Utils()
      let platform = utilsHelper.checkPlatform()
      console.log('empty_platform ', platform )
      if (platform === 'cyberbiz') {
        container_id = await utilsHelper.getCybMerchantId()
      }
      console.log('empty_platform_container_id', container_id )
    } catch (error) {
      console.error('get_cb_shop_id_error', error)
    }
  }

  console.log("optimize99_APP_MODE: ", APP_MODE);
  console.log("optimize99_initializeSDK: ", container_id);

  // 防止同一個container重複啟用的狀況
  if (window.opt99.containers.includes(container_id)) {
    console.log("initializeSDK_duplicate_detected", container_id);
    return;
  } else {
    window.opt99.containers.push(container_id);
  }

  try {
    // 在localStorage建立container的view的紀錄和clid
    const storage_key = `_opt99_${container_id}`;
    let container_storage = {
      clid: "",
      view_product: {},
    };
    if (localStorage.getItem(storage_key)) {
      try {
        container_storage = JSON.parse(localStorage.getItem(storage_key));
      } catch (error) {
        console.log("optimize99_container_storage_error", error);
      }
    }

    console.log("container_storage", container_storage);
    localStorage.setItem(storage_key, JSON.stringify(container_storage));
    // console.log('optimize99_container_storage_' + storage_key, container_storage)

    let logHelper = new LogHelper(config.LOG_ENDPOINT, is_debug, container_id);
    // 事件追蹤
    try {
      const eventTracker = new EventTracker(
        container_id,
        config,
        is_debug,
        storage_key
      );
      eventTracker.run();
    } catch (error) {
      logHelper.send({
        level: "error",
        stage: "global_catch_eventTracker",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    try {
      let subscriptionTable = new SubscriptionTable(config);
      subscriptionTable.display();
    } catch (error) {
      logHelper.send({
        level: "error",
        stage: "global_subscriptionTable",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    // 頁面優化
    try {
      const optimizePage = new OptimizePage(
        container_id,
        config,
        is_debug,
        storage_key
      );
      optimizePage.run();
    } catch (error) {
      logHelper.send({
        level: "error",
        stage: "global_catch_optimizePage",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    // try {

    //   // 行銷圖卡
    //   let marketingCard = new MarketingCard(container_id, config, is_debug, storage_key)
    //   marketingCard.run(window.location.href)

    // } catch (error) {
    //   logHelper.send({
    //     "level": 'error',
    //     "stage": 'global_catch_marketingCard',
    //     'error_trace': {
    //       error_message: error.message,
    //       error_stack: error.stack
    //     }
    //   })
    // }

    try {
      // 登入檢測
      let detectLogin = new DetectLogin(
        container_id,
        config,
        is_debug,
        storage_key
      );
      detectLogin.run(window.location.href);
    } catch (error) {
      logHelper.send({
        level: "error",
        stage: "global_catch_detectLogin",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    try {
      let detectInstallSDK = new DetectInstallSDK(
        container_id,
        config,
        is_debug
      );
      detectInstallSDK.run(window.location.href);
    } catch (error) {
      logHelper.send({
        level: "error",
        stage: "global_catch_detectInstallSDK",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    try {
      let iframeMessageListener = new IframeMessageListener(
        container_id,
        config,
        is_debug
      );
      iframeMessageListener.start();
      console.log("iframeMessageListener_start");
    } catch (error) {
      console.log("iframeMessageListener_error", error);
      logHelper.send({
        level: "error",
        stage: "global_iframeMessageListener",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }

    // 全站性質只做一次的不管container
    if (window.opt99.containers.length === 1) {
      try {
        let autoCoupon = new AutoCoupon();
        autoCoupon.run(window.location.href);
      } catch (error) {
        logHelper.send({
          level: "error",
          stage: "global_catch_autoCoupon",
          error_trace: {
            error_message: error.message,
            error_stack: error.stack,
          },
        });
      }
    }
  } catch (error) {
    let logHelper = new LogHelper(config.LOG_ENDPOINT, is_debug, container_id);
    logHelper.send({
      level: "error",
      stage: "global_catch",
      error_trace: {
        error_message: error.message,
        error_stack: error.stack,
      },
    });
  }
}


// 正式要用這個
// if (!window.opt99) {
//   window.opt99 = {
//     initialize: initializeSDK,
//     containers: [],
//   }
// }
// 本地debug要用這個
if (APP_MODE === 'development' || APP_MODE === 'staging') {
  window.opt99 = {
    initialize: initializeSDK,
    containers: [],
  };
}
else {
  if (!window.opt99) {
    window.opt99 = {
      initialize: initializeSDK,
      containers: [],
    }
  }
}


